import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TodoTitle } from "../Types/Todo/TodoInterface";
import { getAllTodoData } from "../Thunks/todoThunks";

interface TodoState {
    allTodoTitles: TodoTitle[];
    loadingTodoTitles: boolean;
    errorTodoTitles: string | null;
    
}

const initialState: TodoState = {
    allTodoTitles: [],
    loadingTodoTitles: false,
    errorTodoTitles: null
}

const todoSlice = createSlice ({
    name: 'todo',
    initialState,
    reducers : {},
    extraReducers(builder){
        builder.addCase(getAllTodoData.rejected, (state, action) => {
            state.loadingTodoTitles = false;
            state.errorTodoTitles = action.error.message!;
          })
            .addCase(getAllTodoData.pending, state => {
            state.loadingTodoTitles = true;
            state.errorTodoTitles = null;
          })
          .addCase(getAllTodoData.fulfilled, (state, action: PayloadAction<TodoTitle[]>) => {
            state.loadingTodoTitles = false;
            state.allTodoTitles = action.payload;
            
          })
    }

})

export const {} = todoSlice.actions
export default todoSlice.reducer